const reducerName = '@cityoo-tenant/form/prior-communication';

export const RESET = `${reducerName}/RESET`;

export const UPDATE_PRIOR_COMMUNICATION_START = `${reducerName}/UPDATE_PRIOR_COMMUNICATION_START`;
export const UPDATE_PRIOR_COMMUNICATION_SUCCESS = `${reducerName}/UPDATE_PRIOR_COMMUNICATION_SUCCESS`;
export const UPDATE_PRIOR_COMMUNICATION_FAIL = `${reducerName}/UPDATE_PRIOR_COMMUNICATION_FAIL`;
